/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDailyRateRequest
 */
export interface UpdateDailyRateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyRateRequest
     */
    hidden: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyRateRequest
     */
    price: number;
}

/**
 * Check if a given object implements the UpdateDailyRateRequest interface.
 */
export function instanceOfUpdateDailyRateRequest(value: object): value is UpdateDailyRateRequest {
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function UpdateDailyRateRequestFromJSON(json: any): UpdateDailyRateRequest {
    return UpdateDailyRateRequestFromJSONTyped(json, false);
}

export function UpdateDailyRateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDailyRateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hidden': json['hidden'],
        'price': json['price'],
    };
}

export function UpdateDailyRateRequestToJSON(value?: UpdateDailyRateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hidden': value['hidden'],
        'price': value['price'],
    };
}

